module.exports = __webpack_public_path__ + "img/autorenew.51f9d3ca.svg";